import {Typography} from '@mui/material'
import {useTheme} from '@mui/material/styles'
import {ReactNode} from 'react'

export interface CardPropertyProps {
  label: string | ReactNode
  children?: ReactNode | ReactNode[] | string | string[]
}

export const CardProperty = (props: CardPropertyProps) => {
  const theme = useTheme()

  return (
    <>
      <Typography
        variant='caption'
        color={theme.palette.text.disabled}
        align='left'
        noWrap
      >
        {props.label}
      </Typography>
      <Typography
        variant='body2'
        color={theme.palette.text.primary}
        align='left'
        sx={{
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitBoxOrient: 'vertical'
        }}
        data-testid='cardlabel-value'
      >
        {props.children}
      </Typography>
    </>
  )
}
